import { fossaPlanMap, FREE_PLAN_NAME } from '../../../../../shared/subscriptions/consts';
import { isEnterpriseTier } from '../../../../../shared/subscriptions/utils';
import { Action, ResourceType } from '../../../../../typings/permissions';
import { useOnAlert } from '../../../../contexts/DialogContext';
import { window } from '../../../../globals';
import Flex from '../../../generic/Flex';
import MailToLink from '../../../generic/Link/MailToLink';
import RouterLink from '../../../generic/Link/RouterLink';
import BoldText from '../../../generic/Text/BoldText';

const useShowReleaseGroupLimitModal = () => {
  const onAlert = useOnAlert();

  const plan = window.user?.organization?.stripe_plan ?? FREE_PLAN_NAME;
  const planInfo = fossaPlanMap[plan];

  const canEditBilling =
  !window.on_prem &&
  window.hasPermission({
    action: Action.Edit,
    resourceType: ResourceType.OrganizationBillingSettings,
  });

  const isEnterprise = isEnterpriseTier({ plan, stripePriceLimit: window?.user?.organization?.stripePriceLimit });

  const showReleaseGroupLimitModal = () => {
    onAlert({
      title: 'You have reached the maximum number of release groups',
      body: (
        <Flex direction="column" align="left" gap={16}>
          <div>
            Your organization is currently subscribed to our <BoldText weight="bold">{planInfo.label}: {planInfo.description} Plan</BoldText>.
            {!isEnterprise && ' Upgrade to an enterprise plan to gain additional features.'}
          </div>
          {!isEnterprise && canEditBilling && (
            <div>
              Visit the <RouterLink to="/account/settings/billing">subscription page</RouterLink> to upgrade.
            </div>
          )}
          {isEnterprise && canEditBilling && (
            <div>
              You can increase this limit by contacting our sales team at{' '}
              <MailToLink email="sales@fossa.com">sales@fossa.com</MailToLink>.
            </div>
          )}
        </Flex>
      ),
    });
  };

  return showReleaseGroupLimitModal;
};

export default useShowReleaseGroupLimitModal;
